export { default } from './WhatIsWhatQuestion.js';
